import { useCallback, useEffect, useRef } from "react";
import waSound from "../sounds/whatsapp_bip.mp3";
import humanSupportRequestSound from "../sounds/human_support.mp3";

const useNotificationSounds = () => {
  // Ref para armazenar a instância do áudio humanRequest
  const humanRequestAudioRef = useRef(null);

  const playNotificationSound = useCallback(() => {
    try {
      // Sempre cria um novo áudio para garantir o som correto
      const newAudio = new Audio(waSound);
      newAudio.onerror = (e) => {
        console.error("Audio error:", e);
      };
      newAudio.play().catch((error) => {
        console.error("Error playing notification sound:", error);
      });
    } catch (error) {
      console.error("Error in playNotificationSound:", error);
    }
  }, []);

  const playHumanRequestSound = useCallback(() => {
    try {
      // Para qualquer áudio anterior se estiver tocando
      if (humanRequestAudioRef.current) {
        humanRequestAudioRef.current.pause();
        humanRequestAudioRef.current.currentTime = 0;
      }

      // Cria um novo áudio e armazena a referência
      const newAudio = new Audio(humanSupportRequestSound);
      humanRequestAudioRef.current = newAudio;

      newAudio.onerror = (e) => {
        console.error("Audio error:", e);
      };
      newAudio.loop = true;
      newAudio.play().catch((error) => {
        console.error("Error playing human request sound:", error);
      });
    } catch (error) {
      console.error("Error in playHumanRequestSound:", error);
    }
  }, []);

  const pauseHumanRequestSound = useCallback(() => {
    try {
      if (humanRequestAudioRef.current) {
        humanRequestAudioRef.current.pause();
        humanRequestAudioRef.current.currentTime = 0;
        console.log("Human request sound paused");
      }
    } catch (error) {
      console.error("Error in pauseHumanRequestSound:", error);
    }
  }, []);

  useEffect(() => {
    return () => {
      // Cleanup: para o áudio quando o componente for desmontado
      if (humanRequestAudioRef.current) {
        humanRequestAudioRef.current.pause();
        humanRequestAudioRef.current.currentTime = 0;
      }
    };
  }, []);

  return {
    playNotificationSound,
    playHumanRequestSound,
    pauseHumanRequestSound,
  };
};

export default useNotificationSounds;
